import { useState } from 'react';
import { deserialize, serialize } from 'serializr';
import { generatePath } from 'react-router-dom';
import axiosInstance from '../../interceptor/axiosInstance';
import { ApiRoutes } from './../../routes/routeConstants/apiRoutes';
import { InAppNotification } from '../../models/InAppNotification/inAppNotification.model';
import { PaginationConfig } from 'models/PaginationConfig/paginationConfig.model';

const InAppNotificationService = () => {

  const [loading, setLoading] = useState<boolean>(false)

  const [buttonLoading, setButtonLoading] = useState<boolean>(false)

  const [inAppNotifications, setInAppNotifications] = useState<InAppNotification[]>([])

  const [inAppNotificationsPagination, setInAppNotificationsPagination] = useState<PaginationConfig | null>()

  const [notificationCount, setNotificationCount] = useState<number>(0)

  const fetchInAppNotifications = async (params?: {
    search?: string,
    page?: number,
    append?: boolean
  }) => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(ApiRoutes.IN_APP_NOTIFICATIONS, { params })
      const data = deserialize(InAppNotification, response.data.data) as InAppNotification[]
      const pagination = deserialize(PaginationConfig, response.data)
      if (params?.append) {
        let localData = inAppNotifications
        localData = localData.concat(data)
        setInAppNotifications(localData)
      } else {
        setInAppNotifications(data)
      }
      setInAppNotificationsPagination(pagination)
    } catch (error) {
      setInAppNotifications([])
    } finally {
      setLoading(false)
    }
  }

  const markAllAsread = async () => {
    try {
      setButtonLoading(true)
      await axiosInstance.put(ApiRoutes.IN_APP_NOTIFICATIONS)
    } catch (error) {
      console.error("Error is ", error)
    } finally {
      setButtonLoading(false)
    }
  }

  const markAsRead = async (notificationId: string) => {
    try {
      setButtonLoading(true)
      const API_URL = generatePath(ApiRoutes.IN_APP_NOTIFICATIONS_SPECIFIC, { id: notificationId })
      await axiosInstance.put(API_URL)
    } catch (error) {
      console.error("Error is ", error)
    } finally {
      setButtonLoading(false)
    }
  }

  const fetchUnreadCount = async () => {
    try {
      const response = await axiosInstance.get(ApiRoutes.IN_APP_NOTIFICATIONS_COUNT)
      setNotificationCount(JSON.parse(JSON.stringify(response.data.count)))
    } catch (error) {
      console.error("Error is ", error)
    }
  }

  return {
    loading,
    inAppNotifications,
    buttonLoading,
    fetchInAppNotifications,
    markAllAsread,
    inAppNotificationsPagination,
    markAsRead,
    fetchUnreadCount,
    notificationCount
  }
}

export default InAppNotificationService